'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numKeys = exports.hasIndex = exports.reduceWithKeys = exports.appendFlipped = exports.nthOr = exports.nthFlipped = exports.headEquals = exports.lengthEq1 = undefined;

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var lengthEq1 = exports.lengthEq1 = (0, _ramdaAdjunct.lengthEq)(1);

var headEquals = exports.headEquals = function headEquals(value) {
  return (0, _ramda.compose)((0, _ramda.equals)(value), _ramda.head);
};

var nthFlipped = exports.nthFlipped = (0, _ramda.flip)(_ramda.nth);

var nthOr = exports.nthOr = (0, _ramda.curry)(function (defaultValue, n, a) {
  return (0, _ramda.defaultTo)(defaultValue, (0, _ramda.nth)(n, a));
});

var appendFlipped = exports.appendFlipped = (0, _ramda.flip)(_ramda.append);

var reduceWithKeys = exports.reduceWithKeys = function reduceWithKeys(reducer) {
  return (0, _ramda.converge)((0, _ramda.reduce)(reducer), [_ramda.identity, _ramda.keys]);
};

var hasIndex = exports.hasIndex = (0, _ramda.curry)(function (n, l) {
  return (0, _ramdaAdjunct.lensSatisfies)(_ramdaAdjunct.isNotUndefined, (0, _ramda.lensIndex)(n))(l);
});

var numKeys = exports.numKeys = (0, _ramda.compose)(_ramda.length, _ramda.keys);


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/list.js
// module id = 245
// module chunks = 168707334958949